import { SecurityConstants } from '../security/constants/security-constants';
import { HttpHeaders } from '@angular/common/http';

export class ServicesHelper {
  public static getHeaders(): HttpHeaders {
    let token: string | null = localStorage.getItem(SecurityConstants.TOKEN_KEY);
    if (token !== null) {
      token = 'Bearer ' + token;
    }

    let headers = new HttpHeaders();
    headers = headers.append('Access-Control-Allow-Origin', '*');
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', token || '');
    return headers;
  }

  public static getRequestOptions(): any {
    const headers: HttpHeaders = this.getHeaders();
    const options: any = {
      headers: headers,
      responseType: 'json'
    };
    return options;
  }

  public static getRequestOptionsFormData(): any {
    const headers: HttpHeaders = this.getHeaders();
    headers.delete('Content-Type');
    headers.append('enctype', 'multipart/form-data');
    const options: any = { headers: headers };
    return options;
  }

  public static getRequestOptionsFormDataWithToken(): HttpHeaders {
    let token: string | null = localStorage.getItem(SecurityConstants.TOKEN_KEY);
    if (token !== null) {
      token = 'Bearer ' + token;
    }

    let headers = new HttpHeaders();
    headers = headers.delete('Content-Type');
    headers = headers.append('Access-Control-Allow-Origin', '*');
    headers = headers.append('enctype', 'multipart/form-data');
    headers = headers.append('Authorization', token || '');

    return headers;
  }

  public static serializeObject(data: any): string {
    const response: string = JSON.stringify(data);
    return response;
  }
}
